import * as React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import _toInteger from 'lodash/toInteger';
import { SafetyEventReportDataProvider } from '../../core/context/SafetyEventReportDataContext';
import { DispatchEventFieldOptionsProvider } from '../../core/context/DispatchEventFieldOptionsContext';
import { AuthorizationRequestType } from '../../core/api/clients';

function SafetyEventFormLayout() {
  const { formId } = useParams<'formId'>();
  const { action } = useParams<'action'>();

  let requestType = AuthorizationRequestType.Contribute;
  if (action === 'read') {
    requestType = AuthorizationRequestType.Read;
  } else if (action === 'view') {
    requestType = AuthorizationRequestType.View;
  }

  return (
    <div>
      <SafetyEventReportDataProvider safetyEventReportId={_toInteger(formId)} role={requestType}>
        <DispatchEventFieldOptionsProvider>
          <Outlet />
        </DispatchEventFieldOptionsProvider>
      </SafetyEventReportDataProvider>
    </div>
  );
}

export default SafetyEventFormLayout;
